import WsService from "../WsService";
import UserSessionService from "../UserSessionService";

const ENDPOINT_BASE = "/agents";
export default class AgentService {

    static retrieveByUserId(userId) {

        let endpoint = ENDPOINT_BASE + "?user-id=" + userId;
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        return WsService.getWithHeaders(endpoint, {}, 200, registrationHeaders).then(
            response => {
                return response;
            },
            response => {
                return response;
            }
        )

    }

    static updateAddress(agentId, address) {
        let endpoint = ENDPOINT_BASE + "/" + agentId + "/address";
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        return WsService.putWithHeaders(endpoint, address, 200, registrationHeaders).then(
            response => {
                return response;
            },
            response => {
                return response;
            });
    }

    static updateIdentity(agentId, identity) {
        let endpoint = ENDPOINT_BASE + "/" + agentId + "/identity";
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        return WsService.putWithHeaders(endpoint, identity, 200, registrationHeaders).then(
            response => {
                return response;
            },
            response => {
                return response;
            });
    }

    static updateContact(agentId, contact) {

        let endpoint = ENDPOINT_BASE + "/" + agentId + "/contacts/" + contact.id;
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        return WsService.putWithHeaders(endpoint, contact, 200, registrationHeaders).then(
            response => {
                return response;
            },
            response => {
                return response;
            });
    }

    static updateDocument(agentId, documentId, document) {

        let endpoint = ENDPOINT_BASE + "/" + agentId + "/documents/" + documentId;
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        return WsService.putWithHeaders(endpoint, document, 200, registrationHeaders).then(
            response => {
                return response;
            },
            response => {
                return response;
            });
    }

    static addDocument(agentId, document) {

        let endpoint = ENDPOINT_BASE + "/" + agentId + "/documents";
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        return WsService.postWithHeaders(endpoint, document, 201, registrationHeaders).then(
            response => {
                return response;
            },
            response => {
                return response;
            });
    }

    static addContact(agentId, contact) {
        let endpoint = ENDPOINT_BASE + "/" + agentId + "/contacts";
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        return WsService.postWithHeaders(endpoint, contact, 200, registrationHeaders).then(
            response => {
                return response;
            },
            response => {
                return response;
            });
    }

    static getCompliance(userId) {
        let endpoint = ENDPOINT_BASE + "/compliance?user-id=" + userId;
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        return WsService.getWithHeaders(endpoint, {}, 200, registrationHeaders).then(
            response => {
                return response;
            },
            response => {
                return response;
            }
        )
    }
}